import React, { useState } from 'react';
import {
  FaHandshake,
  FaGlobe,
  FaExternalLinkAlt,
} from 'react-icons/fa';
import Header from '../components/Header';
import Footer from '../components/Footer';

// Composant pour afficher le drapeau
const CountryFlag = ({ countryCode, alt }) => {
  return (
    <img
      src={`https://flagcdn.com/w160/${countryCode}.png`}
      srcSet={`https://flagcdn.com/w320/${countryCode}.png 2x`}
      alt={alt}
      className="country-flag-img"
    />
  );
};

const Centrafrique = () => {

  const countryData = {
    name: 'République Centrafricaine',
    countryCode: 'cf',
  };

  // Liste des partenaires avec leurs logos
  const partners = [
    {
      id: 1,
      name: 'ICASEES',
      logo: '../assets/images/partenaires/centr1.png',

      // url: 'https://pecb.com'
    },
    // {
    //     id: 2,
    //     name: 'Alliance Française de Bangui',
    //     logo: 'https://via.placeholder.com/200x100/0055a4/ffffff?text=Alliance+Française',
    //     category: 'Formation & Culture',
    //     url: '#'
    // },

  ];





  return (
    <>
      <Header />
      <div className="partners-page-wrapper">
        {/* Hero Section avec Drapeau */}
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <div className="flag-hero-container">
                <CountryFlag countryCode={countryData.countryCode} alt={`Drapeau ${countryData.name}`} />
              </div>

              <h1 className="hero-title">
                Nos Partenaires en
                <span className="highlight">{countryData.name}</span>
              </h1>



              <p className="hero-description">
                La République Centrafricaine, au cœur de l'Afrique centrale, bénéficie d'un réseau de partenaires
                engagés dans le développement culturel, éducatif et économique. Ensemble, nous œuvrons pour
                l'émergence des talents et le renforcement des compétences professionnelles.
              </p>


            </div>
          </div>
        </section>

        {/* Grille des Logos Partenaires */}
        <section className="partners-grid-section">
          <div className="container">
            <div className="section-header">

              <h2 className="section-title">Entreprises & Institutions Partenaires</h2>
            </div>

            <div className="partners-grid">
              {partners.map((partner) => (
                <a
                  key={partner.id}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="partner-card"
                >
                  <div className="partner-logo-container">
                    <img
                      src={partner.logo}
                      alt={partner.name}
                      className="partner-logo"
                    />
                  </div>
                  <div className="partner-info">
                    <h3 className="partner-name">{partner.name}</h3>
                    <span className="partner-category">{partner.category}</span>
                  </div>
                  <div className="partner-link-icon">
                    <FaExternalLinkAlt />
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>



        <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .partners-page-wrapper {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
          background: #ffffff;
          margin-top: 40px;
        }

        .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Hero Section */
        .hero-section {
          padding: 80px 0 60px;
          background: linear-gradient(180deg, #fafafa 0%, #ffffff 100%);
          text-align: center;
        }

        .hero-content {
          max-width: 800px;
          margin: 0 auto;
        }

        .flag-hero-container {
          display: inline-block;
          width: 180px;
          height: 120px;
          background: white;
          border-radius: 16px;
          padding: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
          margin-bottom: 32px;
        }

        .country-flag-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 10px;
        }

        .hero-title {
          font-size: 48px;
          font-weight: 900;
          color: #1a202c;
          line-height: 1.2;
          margin-bottom: 16px;
          letter-spacing: -1px;
         
        }

        .highlight {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-left: 8px;
        }

        .hero-location {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 20px;
          background: white;
          border-radius: 50px;
          font-size: 15px;
          color: #718096;
          font-weight: 600;
          margin-bottom: 24px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        .hero-location svg {
          color: #fd7e14;
        }

        .hero-description {
          font-size: 18px;
          color: #4a5568;
          line-height: 1.7;
          margin-bottom: 48px;
        }

        .stats-row {
          display: flex;
          gap: 32px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .stat-box {
          background: white;
          padding: 24px 32px;
          border-radius: 16px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
          text-align: center;
          min-width: 180px;
          border: 2px solid #f7fafc;
          transition: all 0.3s ease;
        }

        .stat-box:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
          border-color: var(--stat-color);
        }

        .stat-icon {
          font-size: 32px;
          color: var(--stat-color);
          margin-bottom: 12px;
        }

        .stat-value {
          font-size: 28px;
          font-weight: 900;
          color: #1a202c;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 13px;
          color: #718096;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        /* Filters Section */
        .filters-section {
          padding: 40px 0;
          background: white;
          border-bottom: 1px solid #e2e8f0;
        }

        .filters-container {
          display: flex;
          align-items: center;
          gap: 20px;
          flex-wrap: wrap;
        }

        .filter-label {
          font-size: 15px;
          font-weight: 600;
          color: #4a5568;
        }

        .categories-pills {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .category-pill {
          padding: 8px 20px;
          background: #f7fafc;
          border: 2px solid #e2e8f0;
          border-radius: 50px;
          font-size: 14px;
          font-weight: 600;
          color: #4a5568;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .category-pill:hover,
        .category-pill.active {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          color: white;
          border-color: transparent;
        }

        /* Partners Grid Section */
        .partners-grid-section {
          padding: 80px 0;
          background: white;
          margin-top: -100px;
        }

        .section-header {
          text-align: center;
          margin-bottom: 56px;
        }

        

        .section-title {
          font-size: 36px;
          font-weight: 900;
          color: #1a202c;
          letter-spacing: -0.5px;
        }

        .partners-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          gap: 24px;
        }

        .partner-card {
          position: relative;
          background: white;
          border: 2px solid #e2e8f0;
          border-radius: 16px;
          padding: 32px 24px;
          text-decoration: none;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .partner-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.12);
          border-color: #fd7e14;
        }

        .partner-logo-container {
          width: 100%;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          background: #f7fafc;
          border-radius: 12px;
          padding: 16px;
        }

        .partner-logo {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }

        .partner-info {
          text-align: center;
          width: 100%;
        }

        .partner-name {
          font-size: 17px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 8px;
          line-height: 1.4;
        }


        .partner-link-icon {
          position: absolute;
          top: 16px;
          right: 16px;
          width: 32px;
          height: 32px;
          background: #f7fafc;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #718096;
          font-size: 14px;
          opacity: 0;
          transition: all 0.3s ease;
        }

        .partner-card:hover .partner-link-icon {
          opacity: 1;
          background: #fd7e14;
          color: white;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .hero-title {
            font-size: 32px;
          }

          .partners-grid {
            grid-template-columns: 1fr;
          }

          .stats-row {
            flex-direction: column;
            gap: 16px;
          }

          .stat-box {
            width: 100%;
          }

          .categories-pills {
            width: 100%;
          }

          .category-pill {
            flex: 1;
            text-align: center;
          }

          .section-title {
            font-size: 28px;
          }

          .cta-card {
            padding: 48px 32px;
          }

          .cta-title {
            font-size: 24px;
          }
        }
      `}</style>
      </div>
      <Footer />
    </>
  );
};

export default Centrafrique;